import { getSessionTools } from "@/components/authentication/utils";
import { useSession } from "@supabase/auth-helpers-react";
import { useMemo } from "react";

export function useAdaptationPermissions(): {
  portfolioAutoAdaptabilityEnabled: boolean;
  portfolioCustomAdaptationEnabled: boolean;
  largeSiteAutoAdaptabilityEnabled: boolean;
};
export function useAdaptationPermissions({ isLargeSite }: { isLargeSite: boolean }): {
  portfolioAutoAdaptabilityEnabled: boolean;
  portfolioCustomAdaptationEnabled: boolean;
  largeSiteAutoAdaptabilityEnabled: boolean;
  canRunAutoAdaptation: boolean;
  canRunCustomAdaptation: boolean;
};

export function useAdaptationPermissions(props?: { isLargeSite: boolean }) {
  const session = useSession();
  const tools = useMemo(() => getSessionTools(session), [session]);

  const portfolioAutoAdaptabilityEnabled = (tools?.comprehensive as any)?.portfolioInsights?.autoAdaptability === true;
  const portfolioCustomAdaptationEnabled =
    (tools?.comprehensive as any)?.portfolioInsights?.userInitiatedAdaptation === true;
  const largeSiteAutoAdaptabilityEnabled = (tools?.comprehensive as any)?.largeSite?.autoAdaptability === true;

  if (props === undefined)
    return {
      portfolioAutoAdaptabilityEnabled,
      portfolioCustomAdaptationEnabled,
      largeSiteAutoAdaptabilityEnabled,
    };

  return {
    portfolioAutoAdaptabilityEnabled,
    portfolioCustomAdaptationEnabled,
    largeSiteAutoAdaptabilityEnabled,
    canRunAutoAdaptation: props?.isLargeSite ? largeSiteAutoAdaptabilityEnabled : portfolioAutoAdaptabilityEnabled,
    canRunCustomAdaptation: props?.isLargeSite ? false : portfolioCustomAdaptationEnabled,
  };
}
